import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import HomePage from "@/pages/HomePage";
import ArticlePage from "@/pages/ArticlePage";
import ContactPage from "@/pages/ContactPage";
import SignalLibraryPage from "@/pages/SignalLibraryPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/context/AuthContext";

// Equilibrium-AI
import EquilibriumHome from "@/pages/equilibrium/EquilibriumHome";
import ModulePage from "@/pages/equilibrium/ModulePage";
import DiagnosticPage from "@/pages/equilibrium/DiagnosticPage";
import EquilibriumLoginPage from "@/pages/equilibrium/EquilibriumLoginPage";
import ConsoleOverview from "@/pages/equilibrium/ConsoleOverview";
import ConsoleProvenance from "@/pages/equilibrium/ConsoleProvenance";
import ConsoleDiagnostics from "@/pages/equilibrium/ConsoleDiagnostics";
import ConsoleModules from "@/pages/equilibrium/ConsoleModules";
import EquilibriumProtectedRoute from "@/components/equilibrium/EquilibriumProtectedRoute";

function App() {
  return (
    <div className="App bg-axiom-bg min-h-screen text-axiom-text antialiased">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Axiom-AI marketing */}
            <Route path="/" element={<HomePage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/signal-library" element={<SignalLibraryPage />} />
            <Route path="/signal-library/:slug" element={<ArticlePage />} />

            {/* Axiom-AI admin */}
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboardPage />
                </ProtectedRoute>
              }
            />

            {/* Equilibrium-AI platform */}
            <Route path="/equilibrium" element={<EquilibriumHome />} />
            <Route path="/equilibrium/modules/:key" element={<ModulePage />} />
            <Route path="/equilibrium/diagnostic" element={<DiagnosticPage />} />
            <Route path="/equilibrium/login" element={<EquilibriumLoginPage />} />
            <Route
              path="/equilibrium/console"
              element={
                <EquilibriumProtectedRoute>
                  <ConsoleOverview />
                </EquilibriumProtectedRoute>
              }
            />
            <Route
              path="/equilibrium/console/provenance"
              element={
                <EquilibriumProtectedRoute>
                  <ConsoleProvenance />
                </EquilibriumProtectedRoute>
              }
            />
            <Route
              path="/equilibrium/console/diagnostics"
              element={
                <EquilibriumProtectedRoute>
                  <ConsoleDiagnostics />
                </EquilibriumProtectedRoute>
              }
            />
            <Route
              path="/equilibrium/console/modules"
              element={
                <EquilibriumProtectedRoute>
                  <ConsoleModules />
                </EquilibriumProtectedRoute>
              }
            />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0A0D14",
            border: "1px solid rgba(255,255,255,0.12)",
            color: "#F8FAFC",
            borderRadius: "2px",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
